
import { useQuery } from "react-query";
import Cookies from "js-cookie";
import { routesName } from "@lib/RoutesName/Routes";
import { privateAgent } from "@lib/Requests/AuthRequests";
import { PaigeResObj } from "@lib/Requests/types";
import { User } from "@lib/Types";


export const useUser = () => {
    return useQuery<User | undefined>(["User"], async () => {
      const userId = Cookies.get("userId");
      if (!userId) {
        throw new Error("User ID not found in cookies");
      }
  
      const { data } = await privateAgent.get<PaigeResObj<User>>(
        routesName.UserRoute({ id: userId }).get_single_user
      );
  
      if (data.status === 200) {
        const results =  data.result
        return results;
      }
  
      throw new Error("Failed to fetch user data");
    });
  };